/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since  2017.6.15
 * @see https://github.com/maximeh/leaflet.bouncemarker
 * @see https://github.com/hosuaby/Leaflet.SmoothMarkerBouncing
 * @see https://github.com/lit-forest/leaflet.magicMarker
 * @see https://gitlab.com/IvanSanchez/Leaflet.GLMarkers
 * @see https://github.com/Oliv/leaflet-polycolor
 * @see https://github.com/bbecquet/Leaflet.RotatedMarker
 * @see https://gitlab.com/IvanSanchez/Leaflet.Marker.SlideTo
 * @see https://github.com/MazeMap/Leaflet.LayerGroup.Collision 碰撞检测
 */
import toSpline from '../utils/SmoothSpline'
import load from "@/utils/Loader";
//
let { assign: $assign } = T;
let { Canvas, point: toPoint, Util, Polyline } = L;
let { requestAnimFrame } = Util;
let { _updatePoly, onAdd } = Canvas.prototype;
/**
 * 
 * @param {*} p 
 * @param {*} angle 弧度值
 */
let toRotate = (p, angle) => {
  angle = Math.atan2(p.y, p.x) + angle;
  let r = Math.sqrt(p.x * p.x + p.y * p.y)//半径
  return {
    x: Math.cos(angle) * r,
    y: Math.sin(angle) * r
  }
}
/**
 * todo 
 * 暂时没有计划拓展svg
 */
// L.SVG.include({
//   _updateCircular(layer) {

//   },
//   _updateTriangle(layer) {

//   },
//   _updateIcon(layer) {

//   }

//   _updateRect(layer){

//  }

//   _updatePoly(layer){

//  }
// })

/** 
 * Canvas 渲染引擎拓展
 */
Canvas.include({

  /**
   * @override 
   */
  onAdd() {
    onAdd.call(this);
    this.options.style && T(this._container).setStyle(this.options.style);
  },
  /**
   * 绘制圆环，台风四象限
   */
  _updateCircular(layer) {
    let that = this;
    if (!that._drawing || layer._empty()) { return; }
    let { _ctx: ctx, _drawnLayers } = that;
    let { _point: p, _radius } = layer;
    _drawnLayers[layer._leaflet_id] = layer;
    //
    let { PI } = Math;
    let iPI = PI / 2;
    ctx.beginPath();
    ctx.arc(p.x, p.y, _radius[0], 0, iPI, false);
    ctx.arc(p.x, p.y, _radius[1], iPI, PI, false);
    ctx.arc(p.x, p.y, _radius[2], PI, iPI * 3, false);
    ctx.arc(p.x, p.y, _radius[3], iPI * 3, PI * 2, false);
    this._fillStroke(ctx, layer);
  },
  /**
   * 绘制三角形图标
   */
  _updateTriangle(layer) {
    let that = this;
    if (!that._drawing || layer._empty()) { return; }
    let { _ctx: ctx, _drawnLayers } = that;
    let { _point: p, _radius: r, _radiusY: ry } = layer;
    let { options } = layer;
    let { angle } = options;
    _drawnLayers[layer._leaflet_id] = layer;
    ry = ry || (r + 3);
    ctx.beginPath();
    let p0 = toRotate({ x: 0, y: -r }, angle);
    let p1 = toRotate({ x: -r, y: ry }, angle);
    let p2 = toRotate({ x: r, y: ry }, angle);
    let { x, y } = p;
    ctx.moveTo(x + p0.x, y + p0.y);
    ctx.lineTo(x + p1.x, y + p1.y);
    ctx.lineTo(x + p2.x, y + p2.y);
    ctx.lineTo(x + p0.x, y + p0.y);
    that._fillStroke(ctx, layer);
  },
  /**
   * 
   * 绘制矩形小图标
   */
  _updateRect(layer) {
    let that = this;
    if (!that._drawing || layer._empty()) { return; }
    let { _ctx: ctx, _drawnLayers } = that;
    let { _point: p, options } = layer;
    let { x, y } = p;
    let width = 9, height = 8.5;
    //
    _drawnLayers[layer._leaflet_id] = layer;
    //
    ctx.beginPath();
    ctx.strokeStyle = options.color || '#222';
    ctx.strokeRect(x - width / 2, y - height / 2, width, height)
    ctx.stroke();
    ctx.beginPath();
    ctx.fillStyle = options.fillColor || options.color
    ctx.fillRect(x - width / 2, y - height / 2, width, height)
    //
    that._fillStroke(ctx, layer);
  },
  /**
   * 绘制图片icon
   */
  _updateIcon(layer) {
    let that = this;
    if (!that._drawing || layer._empty() || layer.options.bounce || layer.options.rotate) { return; }
    let img = layer._loader;
    let { _ctx: ctx, _drawnLayers } = that;
    let p = layer._point;
    _drawnLayers[layer._leaflet_id] = layer;
    //
    // ctx.beginPath();
    ctx.drawImage(img, p.x - img.width / 2, p.y - img.height / 2);

  },
  /**
   * 
   * @param {*} layer 
   * @param {*} closed 
   */
  _updatePoly(layer, closed) {
    let { options } = layer;
    // 光滑线，待拓展，刷新可能有问题
    if (options.spline) {
      let i, j, len2, from, to;
      let { _parts: parts } = layer;
      let newPart = layer._parts = [];//
      let len = parts.length;
      for (i = 0; i < len; i++) {
        let lines = [];
        for (j = 0, len2 = parts[i].length - 1; j < len2; j++) {
          from = parts[i][j];
          to = parts[i][j + 1];
          let points = toSpline(from, to);
          lines = lines.concat(points.map(item => toPoint(item)))
        }
        newPart[i] = lines;
      }
    }
    //
    _updatePoly.call(this, layer, closed);

    let { symbol } = options;
    //
    //符号 箭头
    if (symbol) {
      let { type } = symbol;
      let { _ctx: ctx } = this;
      ctx.beginPath();
      ctx.fillStyle = ctx.strokeStyle = symbol.color || options.color;
      //
      let i, j, len2, from, to;
      let { _parts: parts, _map: map } = layer;
      let len = parts.length;
      switch (type) {
        case 'dike'://堤防
        case 'seawall'://海塘
          for (i = 0; i < len; i++) {
            for (j = 1, len2 = parts[i].length; j < len2; j++) {
              let p1 = parts[i][j];
              let p2 = parts[i][j - 1];
              let d = p1.distanceTo(p2);
              if (d > 8) {
                let count = d / 8;
                let ml = p1.subtract(p2).divideBy(count);
                // (a,b) 顺时针（b,-a),逆时针（-b,a)
                let mv = toPoint(ml.y, -ml.x);
                for (let i = 1; i < count; i++) {
                  let p = p2.add(ml.multiplyBy(i));
                  let v = p.add(mv);
                  ctx.moveTo(v.x, v.y);
                  if (type == "seawall") {
                    p = p.subtract(mv);
                  }
                  ctx.lineTo(p.x, p.y);
                }
              }
            }
          }
          ctx.stroke();
          break;
        default:
          let _buildArrowPath = function (a, b) {
            let d2r = Math.PI / 180;
            let angle = (Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI + 90 + 360) % 360;
            //(Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI + 90 + 360) % 360;
            var direction = -(angle - 90) * d2r;
            var radianArrowAngle = 60 / 2 * d2r;//默认60°
            //
            var pixelSize = symbol.size || 10;//默认10
            var headAngle1 = direction + radianArrowAngle;
            var headAngle2 = direction - radianArrowAngle;
            var arrowHead1 = toPoint(b.x - pixelSize * Math.cos(headAngle1), b.y + pixelSize * Math.sin(headAngle1));
            var arrowHead2 = toPoint(b.x - pixelSize * Math.cos(headAngle2), b.y + pixelSize * Math.sin(headAngle2));
            return [arrowHead1, arrowHead2];
          }
          for (i = 0; i < len; i++) {
            for (j = 0, len2 = parts[i].length - 1; j < len2; j++) {
              from = parts[i][j];
              to = parts[i][j + 1];
              let [p1, p2] = _buildArrowPath(from, to);
              ctx.moveTo(to.x, to.y);
              ctx.lineTo(p1.x, p1.y);
              ctx.lineTo(p2.x, p2.y);
              ctx.closePath();
              ctx.fill();
              layer._pxBounds.extend(p1).extend(p2);//防止箭头因局部刷新没有清除
            }
          }
          break;
      }

    }
  },
  /**
   * 重写 fillStroke 用于填充样式
   * @param {*} ctx 
   * @param {*} layer 
   * @property {horizontal|vertical|cross|forwardDiagonal|backwardDiagonal} pattern  
   */
  _fillStroke(ctx, layer) {
    let { options } = layer;
    let { fill, stroke, weight } = options;
    if (fill) {
      let { pattern, fillColor, color } = options;
      if (pattern) {
        let cvs = T.canvas();
        cvs.width = cvs.height = 12;
        let ctx2 = cvs.getContext('2d');
        ctx2.globalAlpha = 1;
        ctx2.beginPath();
        ctx2.strokeStyle = fillColor || color;
        //
        switch (pattern) {
          case 'horizontal'://(水平)
            ctx2.moveTo(0, 6);
            ctx2.lineTo(12, 6);
            break;
          case 'vertical'://(垂直)
            ctx2.moveTo(6, 0);
            ctx2.lineTo(6, 12);
            break;
          case 'cross'://(十字)
            ctx2.moveTo(0, 6);
            ctx2.lineTo(12, 6);
            ctx2.moveTo(6, 0);
            ctx2.lineTo(6, 12);
            break;
          case 'forwardDiagonal'://(正向斜角)
            ctx2.moveTo(0, 0);
            ctx2.lineTo(12, 12);
            break;
          case 'backwardDiagonal'://(反向斜角)
            ctx2.moveTo(12, 0);
            ctx2.lineTo(0, 12);
            break;
        }
        //
        ctx2.stroke();
        pattern = ctx.createPattern(cvs, 'repeat');
      } else {
        ctx.globalAlpha = options.fillOpacity;
      }
      ctx.fillStyle = pattern || fillColor || color;
      ctx.fill(options.fillRule || 'evenodd');
    }

    if (stroke && weight !== 0) {
      ctx.setLineDash && ctx.setLineDash(options._dashArray || []);//ie10+
      ctx.globalAlpha = options.opacity;
      ctx.lineWidth = weight;
      ctx.strokeStyle = options.color;
      ctx.lineCap = options.lineCap;
      ctx.lineJoin = options.lineJoin;
      if (options.shadowColor) {
        ctx.shadowColor = options.shadowColor;
        ctx.shadowBlur = options.shadowBlur;
      }
      ctx.stroke();
    }
  }
})

/**
 * 动画层
 */
L.Animate = Canvas.extend({
  options: {
    style: { zIndex: 50 }
  },
  /**
   * 
   */
  getEvents() {
    var events = L.Renderer.prototype.getEvents.call(this);
    events.viewprereset = this._onViewPreReset;
    events.zoomstart = this._onZoomStart;
    return events;
  },
  /**
   * 
   */
  _initPath(layer) {
    this._layers[L.stamp(layer)] = layer;
    let { options } = layer;
    options.glowOptions = $assign({
      // 扩散半径
      radius: 16,
      // 半径单位
      unit: 'px',
      // 粗细
      lineWidth: 2,
      // 重叠个数
      overlap: 0,
      // 扩散速度
      speed: 0.3,
      // 颜色
      color: '#ff0000'
    }, options.glowOptions)
    //
    options.flowOptions = $assign({
      // 移动点半径
      radius: 2,
      // 线条宽度
      lineWidth: 1,
      // 移动点颜色
      fillColor: '#fff',
      // 移动点阴影颜色
      shadowColor: '#fff',
      // 移动点阴影大小
      shadowBlur: 5,
      // 移动速度
      speed: 1,
      //
      // src:'',
      //

    }, options.flowOptions);
  },
  _onZoomStart: function () {
    this._update();
  },
  _addPath: function () { },
  _removePath: function (layer) {
    delete this._layers[L.stamp(layer)];
  },
  /**
   * 
   */
  onAdd: function () {
    Canvas.prototype.onAdd.call(this);
    //
    var drawFrame = () => {
      let { _ctx: ctx, _container } = this;
      let { _leaflet_pos } = _container;
      // 判断是否被移除，jsdemo
      if (_container.clientWidth) {
        ctx.fillStyle = 'rgba(0, 0, 0, 0)';
        ctx.clearRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height);
        for (var id in this._layers) {
          let marker = this._layers[id];
          if (marker instanceof Polyline) {
            this._updatePolyline(marker)
          } else {
            if (marker.options.bounce || marker.options.rotate) {
              this._updateIcon(marker);
            } else {
              this._updateCircle(marker);
            }
          }
        }
      }

      requestAnimFrame(drawFrame);
    }
    drawFrame();
  },
  /**
   * 重写 _updatePaths
   */
  _updatePaths: function () {
  },
  /**
   * 
   */
  _updateIcon(layer) {
    let that = this;
    let img = layer._loader;
    if (!img) return;
    let { _ctx: ctx, _drawnLayers } = that;
    let p = layer._point;
    _drawnLayers[layer._leaflet_id] = layer;
    //
    let { options } = layer;
    // 弹跳动画
    if (options.bounce) {
      let bounce = options._bounce = options._bounce || { from: 0, to: 15, y: 0 };
      if (bounce.from < bounce.to) {
        bounce.y += 1;
        if (bounce.y > bounce.to) {
          let temp = bounce.to;
          bounce.to = bounce.from;
          bounce.from = temp;
        }
      } else {
        bounce.y -= 1;
        if (bounce.y < bounce.to) {
          let temp = bounce.to;
          bounce.to = bounce.from;
          bounce.from = temp;
        }
      }
      p = p.clone();
      p.y -= bounce.y;
    }
    // 旋转动画
    let { x, y } = p;
    if (options.rotate) {
      let rotate = options._rotate = options._rotate || { deg: 0 };
      // let { rotateOptions } = options; // 默认逆时针旋转，台风
      ctx.save();
      ctx.beginPath();
      ctx.translate(x, y);
      ctx.rotate(rotate.deg * Math.PI / 180);
      ctx.drawImage(img, - img.width / 2, - img.height / 2)
      ctx.restore();
      rotate.deg -= 5;
    } else {
      ctx.drawImage(img, x - img.width / 2, y - img.height / 2);
    }
  },

  /**
   * 绘制圆,绘制圆形扩散动画
   * @param layer  
   */
  _updateCircle(layer) {
    let { _ctx: ctx } = this;
    let { _point: p, options } = layer;
    //
    options = options.glowOptions;
    let { radius: to, speed, overlap } = options;
    let radius = options._radius || 0;
    //
    if (options.unit === 'm') {//
      let { _map: map, _latlng: latlng } = layer;
      let { crs } = map.options;
      crs = L.CRS.EPSG3857;//todo 暂时
      let latlng2 = crs.unproject(crs.project(latlng).subtract([to, 0]));
      to = p.x - map.latLngToLayerPoint(latlng2).x;
    }
    //
    ctx.beginPath();
    ctx.strokeStyle = options.color;
    ctx.lineWidth = options.lineWidth;
    ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();
    // 绘制重叠圆，wifi
    if (overlap && radius > to / overlap && radius < to) {
      let r = radius;
      while (r > to / overlap) {
        ctx.beginPath();
        ctx.strokeStyle = options.color;
        ctx.lineWidth = options.lineWidth;
        ctx.arc(p.x, p.y, r -= to / overlap, 0, Math.PI * 2);
        ctx.stroke();
        ctx.closePath();
      }
    }
    //
    if (radius + speed > to) {
      radius = overlap ? (radius - to / overlap) : 0;
    } else {
      radius += speed;
    }
    //
    options._radius = radius;
  },
  /**
   * 绘制线,绘制流动的线
   * @param layer
   */
  _updatePolyline(layer) {
    // 默认参数
    let { _ctx: ctx } = this;
    let { _parts: parts, options } = layer;
    let len = parts.length;
    if (!len) { return; }
    options = options.flowOptions;
    //
    ctx.fillStyle = options.fillColor;
    ctx.shadowColor = options.shadowColor;
    ctx.shadowBlur = options.shadowBlur;
    //
    let flows = options._flows = options._flows || [];
    //
    parts.forEach((line, index) => {
      let points = getPoints(line);
      if (points.length > 0) {
        let ci = flows[index];
        if (!ci || ci >= points.length) {
          ci = flows[index] = 0;
        }
        ci = Math.floor(ci);
        let [x, y] = points[ci];
        if (options.renderFn) { // 自定义绘制方式
          options.renderFn(ctx, x, y)
        } else if (options.src) {
          load(options.src).then(img => {
            ctx.beginPath();
            ctx.drawImage(img, x - img.width / 2, y - img.height);
            ctx.closePath();
          })
        } else {
          ctx.beginPath();
          ctx.arc(x, y, options.radius, 0, Math.PI * 2, true);
          ctx.fill();
          ctx.closePath();
        }
        // console.log('-', this._map.layerPointToLatLng(line[0]))
        // console.log('=', this._map.containerPointToLatLng(line[0]))
        // latLngToLayerPoint
        // layerPointToLatLng
        layer.fire('flow', { points: points, point: points[ci] })
        flows[index] += options.speed;
      }
    });
  }
})

/**
 * 闪烁光晕层
 */
L.Glow = L.Animate.extend({
  /**
   * 
   */
  onAdd() {
    Canvas.prototype.onAdd.call(this);
    //
    let { _ctx: ctx, _container } = this;
    let { _leaflet_pos } = _container;
    //
    let i = 0;
    var drawFrame = () => {
      if (_container.clientWidth) {
        // 默认值为source-over
        var prev = ctx.globalCompositeOperation;
        // 只显示canvas上原图像的重叠部分
        ctx.globalCompositeOperation = 'destination-in';
        // 设置透明度
        ctx.fillStyle = 'rgba(0,0,0,.9)';
        // 设置主canvas的绘制透明度
        ctx.fillRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height);
        // global
        ctx.globalCompositeOperation = prev;
        // 
        for (var id in this._layers) {
          let marker = this._layers[id];
          if (marker instanceof Polyline) {
            this._updatePolyline(marker)
          } else {
            if (marker.options.bounce) {
              this._updateIcon(marker);
            } else {
              this._updateCircle(marker);
            }
          }
        }
      }
      requestAnimFrame(drawFrame);
    }
    drawFrame()
  }
})


/**
 * 获取线上的点集合
 * @param {Array} line 
 */
let getPoints = line => {
  var points = [];
  if (line.length < 2) {
    return;
  }
  for (var i = 0; i < line.length; i++) {
    var start = line[i];
    var end = line[i + 1];
    if (start && end) {
      start = [start.x, start.y];
      end = [end.x, end.y];
      var distance = Math.floor(getDistance(start, end));
      var vx = (end[0] - start[0]) / distance;
      var vy = (end[1] - start[1]) / distance;
      for (var j = 0; j < distance; j++) {
        points.push([start[0] + vx * j, start[1] + vy * j]);
      }
    }
  }
  return points;
};


/**
 * 遮罩层
 */
L.Mask = Canvas.extend({
  getEvents() {
    var events = L.Renderer.prototype.getEvents.call(this);
    events.viewprereset = this._onViewPreReset;
    // if (!this._onMove) {
    //   this._onMove = L.Util.throttle(this._update, 50, this);
    // }
    events.move = this._update;
    return events;
  },
  _updatePoly(layer, closed) {
    let { options } = layer;
    let { _ctx: ctx, _container } = this;
    let { _leaflet_pos } = _container;
    let prev;
    // 
    ctx.beginPath();
    ctx.fillStyle = 'rgba(0,26,51,.7)';
    // transform
    ctx.clearRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height)
    ctx.fillRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height);
    prev = ctx.globalCompositeOperation;
    ctx.globalCompositeOperation = "destination-out";
    // 
    _updatePoly.call(this, layer, closed);
    ctx.globalCompositeOperation = prev;
    //
    // 将strokeStyle的属性值设为该 CanvasGradient 对象
    options.fillOpacity = 0;
    _updatePoly.call(this, layer, closed);
    options.fillOpacity = 1;
  }
})
/**
 * 获取两点之间距离
 * @param {*} p1 
 * @param {*} p2 
 */
let getDistance = (p1, p2) => Math.sqrt((p1[0] - p2[0]) * (p1[0] - p2[0]) + (p1[1] - p2[1]) * (p1[1] - p2[1]));


// WEBPACK FOOTER //
// ./src/polyfill/Renderer.js